import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-content-between flex-wrap" }
const _hoisted_2 = { class: "confirmation-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle mr-3",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_KoruActionButton = _resolveComponent("KoruActionButton")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      class: _normalizeClass(`p-datatable-${_ctx.moduleRef.suffix}`),
      dataKey: "id",
      paginator: false,
      responsiveLayout: "scroll",
      onRowReorder: _ctx.onReorder,
      showGridlines: "",
      stateKey: `datatable-${_ctx.moduleRef.suffix}`,
      stripedRows: "",
      value: _ctx.moduleRef.documents.value
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            (_ctx.moduleRef.canCreate && _ctx.user.canCreate(_ctx.requiredModule))
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "mr-4",
                  icon: "pi pi-plus",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createAction()))
                }, null, 512)), [
                  [
                    _directive_tooltip,
                    _ctx.t('buttons.create'),
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "buttons")
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
      ]),
      loading: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.user.canUpdate(_ctx.requiredModule) !== false)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              rowReorder: true,
              header: _ctx.t('gen.reorder'),
              style: {"width":"5%","text-align":"center"}
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "columns"),
        _createVNode(_component_Column, {
          headerStyle: "width: 10%; text-align: center",
          bodyStyle: "text-align: center; overflow: visible",
          header: _ctx.t('gen.actions')
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_KoruActionButton, {
              model: _ctx.getContextCommands(data),
              reference: data
            }, null, 8, ["model", "reference"])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 3
    }, 8, ["class", "onRowReorder", "stateKey", "value"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDeleteItemDialog,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDeleteItemDialog) = $event)),
      style: { width: '450px' },
      header: _ctx.t('gen.deleteTitle'),
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.t('gen.no'),
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteItemDialog = false))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          label: _ctx.t('gen.yes'),
          icon: "pi pi-check",
          class: "p-button-text",
          onClick: _ctx.deleteItemAction
        }, null, 8, ["label", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.t("gen.deleteConfirm")) + " ", 1),
            (_ctx.moduleRef.deleteDescriptionField == undefined)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.t("gen.deleteObject")), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.DataHelpers.getObjectValueByNestedKey(_ctx.deleteItem, _ctx.moduleRef.deleteDescriptionField)), 1),
                  _createTextVNode(" ? ")
                ]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}